/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import AppToast from "components/AppToast"
import Footer from "components/Footer"
import Navbar from "components/Header"
import SentryErrorBoundary from "components/SentryErrorBoundary"
import About from "pages/About"
import Calculator from "pages/Calculator"
import Contact from "pages/Contact"
import Disclaimers from "pages/Disclaimers"
import Guide from "pages/Guide"
import Methodology from "pages/Methodology"
import NotFound from "pages/NotFound"
import Privacy from "pages/Privacy"
import Terms from "pages/Terms"
import { useEffect } from "react"
import { Route, BrowserRouter as Router, Routes, useLocation } from "react-router"

/**
 * Inner component that has access to location via useLocation hook
 */
const AppContent = () => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <SentryErrorBoundary>
      <AppToast />
      <div className="bg-light min-vh-100 d-flex flex-column">
        <div className="flex-grow-1 d-flex flex-column">
          <div className="container shadow-sm bg-white rounded my-0 my-sm-5 mb-3 mb-sm-5">
            <Navbar />
            <main className="px-2 px-sm-4 px-md-4 pb-3 px-lg-5">
              <Routes>
                <Route path="/" element={<Calculator />} />
                <Route path="/about" element={<About />} />
                <Route path="/methodology" element={<Methodology />} />
                <Route path="/guide" element={<Guide />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/disclaimers" element={<Disclaimers />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="*" element={<NotFound />} /> {/* 404 page */}
              </Routes>
            </main>
          </div>
        </div>
        <Footer />
      </div>
    </SentryErrorBoundary>
  )
}

/**
 * Main App component that wraps AppContent with Router
 */
const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default App
